import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Store } from '../Utils/Store'

const ServicesSidebar = ({ currentSubcategoryId = null, currentCategoryId = null }) => {
  const { state } = useContext(Store)
  const [categories, setCategories] = useState(state.Categories || [])
  const [subcategories, setSubcategories] = useState(state.Subcategories || [])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // Sync with Store
    setCategories(state.Categories || [])
    setSubcategories(state.Subcategories || [])
    setLoading(false)
  }, [state.Categories, state.Subcategories])

  if (loading) {
    return (
      <ul className="aside-widgets">
        <li className="widget widget_nav_menu clearfix">
          <div className="title">
            <h3>My Services</h3>
          </div>
          <ul className="menu">
            <li className="menu-item">Loading...</li>
          </ul>
        </li>
      </ul>
    )
  }

  // Group subcategories by category (handle both string and numeric IDs)
  const servicesByCategory = categories.map(category => ({
    ...category,
    subcategories: subcategories.filter(sub => String(sub.category_id) === String(category.id))
  })).filter(cat => cat.subcategories.length > 0)

  return (
    <ul className="aside-widgets">
      <li className="widget widget_nav_menu clearfix">
        <div className="title">
          <h3>My Services</h3>
        </div>
        <ul className="menu">
          {servicesByCategory.map(category => (
            <React.Fragment key={category.id}>
              {category.subcategories.map(subcategory => (
                <li 
                  key={subcategory.id}
                  className={`menu-item ${String(subcategory.id) === String(currentSubcategoryId) ? 'current-menu-item' : ''}`}
                >
                  <Link to={`/service/${subcategory.id}`}>
                    {subcategory.name}
                  </Link>
                </li>
              ))}
            </React.Fragment>
          ))}
        </ul>
        {/* .menu end */}
      </li>
      {/* .widget.widget_nav_menu end */}
    </ul>
  )
}

export default ServicesSidebar
